import React, { Children } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { breakpoints } from 'app/variables';

const Container = styled.div`
  @media (min-width: ${breakpoints.medium}) {
    display: flex;
    margin: 0 -0.5rem;

    & > div {
      padding: 0 0.5rem;
      width: 50%;
    }
  }
`;

function FormGroup({ children, ...rest }) {
  return (
    <Container {...rest}>
      {Children.map(children, (child) => (
        <div>{child}</div>
      ))}
    </Container>
  );
}

FormGroup.propTypes = {
  children: PropTypes.node,
};

export default FormGroup;
